import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby"
import useTranslations from "hooks/useTranslations"
import NumberedList from "components/organisms/common/NumberedList"

const StepsImage = ({ className }) => {
  const images = useStaticQuery(graphql`
    {
      conversationImage: file(
        relativePath: { eq: "pro/austin-distel-mpN7xjKQ_Ns-unsplash.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 1200)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      image={getImage(images.conversationImage)}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "right center",
      }}
      className={className}
    />
  )
}

export default function NumberedListPro(props) {
  const {
    proHowDoWeHelpTitle,
    proStepsItem1,
    proStepsItem2,
    proStepsItem3,
    proStepsItem1Title,
    proStepsItem2Title,
    proStepsItem3Title,
  } = useTranslations()

  const items = [
    {
      description: proStepsItem1,
      title: proStepsItem1Title,
      number: 1,
    },
    {
      description: proStepsItem2,
      title: proStepsItem2Title,
      number: 2,
    },
    {
      description: proStepsItem3,
      title: proStepsItem3Title,
      number: 3,
    },
  ]

  return (
    <NumberedList
      title={proHowDoWeHelpTitle}
      items={items}
      Image={StepsImage}
      {...props}
    />
  )
}
